import { createContext, useState } from 'react';

import { MultiStepContextType, Step } from './types';

export const MultiStepContext = createContext<MultiStepContextType | null>(null);

export type MultiStepProps = {
  steps: Step[];
  initialStep?: string;
};

const MultiStep = ({ steps, initialStep }: MultiStepProps) => {
  const stepMap = steps.reduce(
    (acc, step) => {
      acc[step.id] = step;
      return acc;
    },
    {} as Record<string, Step>
  );

  const [currentStepId, setCurrentStepId] = useState(initialStep || steps[0]?.id);

  const goToStep = (newStepId: string) => {
    if (stepMap[newStepId]) {
      setCurrentStepId(newStepId);
    } else {
      console.warn(`Step ID ${newStepId} does not exist in steps.`);
    }
  };

  const currentStep = stepMap[currentStepId] ?? undefined;

  if (!currentStep) {
    return null;
  }

  return (
    <MultiStepContext.Provider value={{ currentStep, goToStep, steps }}>
      {currentStep?.component}
    </MultiStepContext.Provider>
  );
};

export default MultiStep;
